// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__KcvIr.styles_ocean-50__CREz6 {
  color: #e6f2ff;
}

.styles_color__KcvIr.styles_ocean-100__Y9DqR {
  color: #e6f2ff;
}

.styles_color__KcvIr.styles_ocean-200__NECAX {
  color: #b3daff;
}

.styles_color__KcvIr.styles_ocean-300__g1iim {
  color: #7abfff;
}

.styles_color__KcvIr.styles_ocean-400__0Qh3V {
  color: #2392fb;
}

.styles_color__KcvIr.styles_ocean-500__2Fd0x {
  color: #0074e0;
}

.styles_color__KcvIr.styles_ocean-600__LAd03 {
  color: #043571;
}

.styles_color__KcvIr.styles_space-50__fNji4 {
  color: #f0f0f0;
}

.styles_color__KcvIr.styles_space-100__pu3\\+V {
  color: #e3e3e3;
}

.styles_color__KcvIr.styles_space-200__GoWre {
  color: #bfbfbf;
}

.styles_color__KcvIr.styles_space-300__Q8NF1 {
  color: gray;
}

.styles_color__KcvIr.styles_space-400__l0jgp {
  color: #616161;
}

.styles_color__KcvIr.styles_space-500__wiLd- {
  color: #283439;
}

.styles_color__KcvIr.styles_gray-50__2m\\+Bk {
  color: #eff3f6;
}

.styles_color__KcvIr.styles_gray-100__iLEO9 {
  color: #e6ecef;
}

.styles_color__KcvIr.styles_gray-200__u3gw1 {
  color: #cfd8de;
}

.styles_color__KcvIr.styles_gray-300__YJhsG {
  color: #a8b9c2;
}

.styles_color__KcvIr.styles_gray-400__47qPP {
  color: #7e98a5;
}

.styles_color__KcvIr.styles_gray-500__8LbJO {
  color: #738f9c;
}

.styles_color__KcvIr.styles_green-50__aCegy {
  color: #e3fdf6;
}

.styles_color__KcvIr.styles_green-100__e1F7k {
  color: #c5f6ea;
}

.styles_color__KcvIr.styles_green-200__kp3ek {
  color: #69ddc2;
}

.styles_color__KcvIr.styles_green-300__Hdyn3 {
  color: #45bfa3;
}

.styles_color__KcvIr.styles_green-400__CZLZR {
  color: #1cab8a;
}

.styles_color__KcvIr.styles_green-500__nCqO3 {
  color: #128268;
}

.styles_color__KcvIr.styles_red-50__-5tn- {
  color: #fff0f3;
}

.styles_color__KcvIr.styles_red-100__GE2Ap {
  color: #f9d2db;
}

.styles_color__KcvIr.styles_red-200__f6i3B {
  color: #f8b4c4;
}

.styles_color__KcvIr.styles_red-300__4fXTG {
  color: #e85e81;
}

.styles_color__KcvIr.styles_red-400__sIs\\+s {
  color: #e23661;
}

.styles_color__KcvIr.styles_red-500__ByTB2 {
  color: #b82348;
}

.styles_color__KcvIr.styles_yellow-50__c2Do\\+ {
  color: #fffae6;
}

.styles_color__KcvIr.styles_yellow-100__Pzc6S {
  color: #fff0b3;
}

.styles_color__KcvIr.styles_yellow-200__0AOYM {
  color: #ffe380;
}

.styles_color__KcvIr.styles_yellow-300__oyW2j {
  color: #ffcf57;
}

.styles_color__KcvIr.styles_yellow-400__VJ9GH {
  color: #ffc60a;
}

.styles_color__KcvIr.styles_yellow-500__0DMEJ {
  color: #ffb700;
}

.styles_color__KcvIr.styles_orange-50__w3iIn {
  color: #fff2eb;
}

.styles_color__KcvIr.styles_orange-100__Bps-I {
  color: #ffe4d6;
}

.styles_color__KcvIr.styles_orange-200__tAb8B {
  color: #ffc69e;
}

.styles_color__KcvIr.styles_orange-300__2t9CL {
  color: #ffa047;
}

.styles_color__KcvIr.styles_orange-400__GoNYj {
  color: #ff7b42;
}

.styles_color__KcvIr.styles_orange-500__BAfjY {
  color: #ee4920;
}

.styles_color__KcvIr.styles_turquoise-50__OgkhP {
  color: transparent;
}

.styles_color__KcvIr.styles_turquoise-100__oUxLC {
  color: #e6fcff;
}

.styles_color__KcvIr.styles_turquoise-200__aqtgi {
  color: #b3f5ff;
}

.styles_color__KcvIr.styles_turquoise-300__B4RnS {
  color: #78e2f2;
}

.styles_color__KcvIr.styles_turquoise-400__FlUyo {
  color: #00c7e6;
}

.styles_color__KcvIr.styles_turquoise-500__br9Kj {
  color: transparent;
}

.styles_color__KcvIr.styles_turquoise-600__vDE2v {
  color: transparent;
}

.styles_color__KcvIr.styles_violet-50__LBVA7 {
  color: #eae6ff;
}

.styles_color__KcvIr.styles_violet-100__BxoCx {
  color: #d9d1ff;
}

.styles_color__KcvIr.styles_violet-200__RZwPP {
  color: #bfb3ff;
}

.styles_color__KcvIr.styles_violet-300__accxA {
  color: #9d90ea;
}

.styles_color__KcvIr.styles_violet-400__hdgk3 {
  color: #8678d9;
}

.styles_color__KcvIr.styles_violet-500__iO0Wy {
  color: #6f5ccc;
}

.styles_color__KcvIr.styles_snow-50__77zsU {
  color: white;
}

.styles_color__KcvIr.styles_snow-100__e-Log {
  color: #f7f7f7;
}

.styles_color__KcvIr.styles_snow-200__K2XAV {
  color: #f0efef;
}

.styles_color__KcvIr.styles_snow-300__GFtEX {
  color: #e6e6e6;
}

.styles_color__KcvIr.styles_snow-400__6Qyqv {
  color: #e1e0e0;
}

.styles_color__KcvIr.styles_snow-500__KQndH {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__bKCRY.styles_ocean__yJH2f {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__bKCRY.styles_ocean-light__Q9OcC {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__bKCRY.styles_green__yP6hQ {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__bKCRY.styles_green-light__apfnt {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__bKCRY.styles_red__NRWrr {
  background-color: #e23661;
  color: white;
}

.styles_background-color__bKCRY.styles_red-light__WJy3u {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__bKCRY.styles_orange__bcx7t {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__bKCRY.styles_orange-light__Zzcv7 {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__bKCRY.styles_space__dIFtP {
  background-color: #616161;
  color: white;
}

.styles_background-color__bKCRY.styles_space-light__j\\+Koe {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__bKCRY.styles_gray-light__lM1td {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__bKCRY.styles_violet__nbz\\+Z {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__bKCRY.styles_violet-light__dkfrj {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__bKCRY.styles_yellow__7QPcM {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__bKCRY.styles_yellow-light__rL3pH {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_root__1d62\\+ {
  -webkit-appearance: none;
          appearance: none;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  color: inherit;
  cursor: pointer;
  margin: 0;
  outline: 0;
  padding: 0;
  position: relative;
  -webkit-tap-highlight-color: transparent;
  text-align: left;
  text-decoration: none;
  -webkit-user-select: none;
          user-select: none;
  vertical-align: middle;
  font-weight: 400;
  font-size: 1rem;
  letter-spacing: -0.09px;
  line-height: 20px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
  align-items: center;
  cursor: default;
  display: flex;
  height: 100%;
}
.styles_root__1d62\\+::-moz-focus-inner {
  border-style: none;
}
.styles_root__1d62\\+.styles_disabled__PDMId {
  cursor: default;
  pointer-events: none;
}
.styles_root__1d62\\+.styles_clickable__hb1GI {
  cursor: pointer;
}
.styles_root__1d62\\+.styles_startAdornment__r-TDH {
  padding-left: 8px ;
}
.styles_root__1d62\\+.styles_endAdornment__tTAXo {
  padding-right: 8px ;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/ui-kit/components/input-adornment/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_misc.scss","webpack://./src/ui-kit/styles/_theme/_typography.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EEuBI,wBAAA;UAAA,gBAAA;EACA,6BAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,sBAAA;ECaA,gBAAA;EANA,eAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;EHCrB,mBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;AA2VJ;AE3TI;EACI,kBAAA;AF6TR;AA5VI;EACI,eAAA;EACA,oBAAA;AA8VR;AA3VI;EACI,eAAA;AA6VR;AA1VI;EACI,kBAAA;AA4VR;AAzVI;EACI,mBAAA;AA2VR","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.root {\n    @include theme.reset-button();\n    @include theme.typo(body3);\n\n    align-items: center;\n    cursor: default;\n    display: flex;\n    height: 100%;\n\n    &.disabled {\n        cursor: default;\n        pointer-events: none;\n    }\n\n    &.clickable {\n        cursor: pointer;\n    }\n\n    &.startAdornment {\n        padding-left: theme.spacing(1);\n    }\n\n    &.endAdornment {\n        padding-right: theme.spacing(1);\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:math';\n@use 'sass:meta';\n@use './colors';\n\n@function if-important($important) {\n    @return #{if($important, '!important', '')};\n}\n\n@function strip-unit($value) {\n    @if meta.type-of($value) == 'number' and not math.is-unitless($value) {\n        @return math.div($value, ($value * 0 + 1));\n    }\n\n    @return $value;\n}\n\n@function is-map($variable) {\n    @return meta.type-of($variable) == 'map';\n}\n\n@function is-string($variable) {\n    @return meta.type-of($variable) == 'string';\n}\n\n// Reset the button to behave like div\n@mixin reset-button() {\n    appearance: none;\n    background-color: transparent;\n    border: 0;\n    border-radius: 0;\n    color: inherit;\n    cursor: pointer;\n    margin: 0;\n    outline: 0;\n    padding: 0;\n    position: relative;\n    -webkit-tap-highlight-color: transparent;\n    text-align: left;\n    text-decoration: none;\n    user-select: none;\n    vertical-align: middle;\n\n    &::-moz-focus-inner {\n        border-style: none;\n    }\n}\n\n@mixin scrollbar() {\n    // The new standard syntax (Currently only supported in Firefox)\n    scrollbar-color: colors.color(gray-200) colors.color(snow-50);\n    scrollbar-width: thin;\n\n    // For Chrome, Edge, Safari, and Opera\n    ::-webkit-scrollbar {\n        height: 7px;\n        width: 5px;\n    }\n\n    ::-webkit-scrollbar-thumb {\n        background: colors.color(gray-200);\n        border-radius: 5px;\n    }\n\n    ::-webkit-scrollbar-track {\n        background: transparent;\n    }\n\n    ::-webkit-scrollbar-thumb:hover {\n        background: colors.color(gray-200);\n    }\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use 'misc' as *;\n\n$typography-html-font-size: 14px;\n$typography-font-size: 14px;\n$typography-font-family: 'Inter',\n    system-ui,\n    -apple-system,\n    'Segoe UI',\n    'Roboto',\n    'Noto Sans',\n    'Ubuntu',\n    'Cantarell',\n    'Helvetica Neue';\n\n$typography-font-weights: (\n    regular: 400,\n    medium: 500,\n    bold: 700\n);\n\n$typography-variants: (\n    h1: 24px medium 34px -0.47px,\n    h2: 20px medium 30px -0.33px,\n    h3: 20px regular 30px -0.33px,\n    h4: 16px bold 24px -0.18px,\n    h5: 16px medium 24px -0.18px,\n    body1: 14px bold 20px -0.09px,\n    body2: 14px medium 20px -0.09px,\n    body3: 14px regular 20px -0.09px,\n    info1: 12px bold 18px 0.01px,\n    info2: 12px medium 18px 0.01px,\n    info3: 12px regular 18px 0.01px,\n);\n\n@function font-weight($weight: regular) {\n    @return map.get($typography-font-weights, $weight);\n}\n\n@function px2rem($value) {\n    @return math.div($value, $typography-html-font-size) * math.div($typography-font-size, 14px) * 1rem;\n}\n\n@mixin typo-by-values($font-size, $font-weight, $line-height, $letter-spacing) {\n    @include font-weight($font-weight);\n\n    font-size: px2rem($font-size);\n    letter-spacing: $letter-spacing;\n    line-height: $line-height;\n}\n\n@mixin font-weight($weight: regular, $important: false) {\n    font-weight: font-weight($weight) if-important($important);\n}\n\n@mixin typo($variant) {\n    $variant-values: map.get($typography-variants, $variant);\n\n    @include typo-by-values($variant-values...);\n\n    // TODO: remove this (if it was redundant) after the new typography replaced the old one\n    font-family: $typography-font-family;\n}\n\n@mixin truncate() {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__KcvIr`,
	"ocean-50": `styles_ocean-50__CREz6`,
	"ocean-100": `styles_ocean-100__Y9DqR`,
	"ocean-200": `styles_ocean-200__NECAX`,
	"ocean-300": `styles_ocean-300__g1iim`,
	"ocean-400": `styles_ocean-400__0Qh3V`,
	"ocean-500": `styles_ocean-500__2Fd0x`,
	"ocean-600": `styles_ocean-600__LAd03`,
	"space-50": `styles_space-50__fNji4`,
	"space-100": `styles_space-100__pu3+V`,
	"space-200": `styles_space-200__GoWre`,
	"space-300": `styles_space-300__Q8NF1`,
	"space-400": `styles_space-400__l0jgp`,
	"space-500": `styles_space-500__wiLd-`,
	"gray-50": `styles_gray-50__2m+Bk`,
	"gray-100": `styles_gray-100__iLEO9`,
	"gray-200": `styles_gray-200__u3gw1`,
	"gray-300": `styles_gray-300__YJhsG`,
	"gray-400": `styles_gray-400__47qPP`,
	"gray-500": `styles_gray-500__8LbJO`,
	"green-50": `styles_green-50__aCegy`,
	"green-100": `styles_green-100__e1F7k`,
	"green-200": `styles_green-200__kp3ek`,
	"green-300": `styles_green-300__Hdyn3`,
	"green-400": `styles_green-400__CZLZR`,
	"green-500": `styles_green-500__nCqO3`,
	"red-50": `styles_red-50__-5tn-`,
	"red-100": `styles_red-100__GE2Ap`,
	"red-200": `styles_red-200__f6i3B`,
	"red-300": `styles_red-300__4fXTG`,
	"red-400": `styles_red-400__sIs+s`,
	"red-500": `styles_red-500__ByTB2`,
	"yellow-50": `styles_yellow-50__c2Do+`,
	"yellow-100": `styles_yellow-100__Pzc6S`,
	"yellow-200": `styles_yellow-200__0AOYM`,
	"yellow-300": `styles_yellow-300__oyW2j`,
	"yellow-400": `styles_yellow-400__VJ9GH`,
	"yellow-500": `styles_yellow-500__0DMEJ`,
	"orange-50": `styles_orange-50__w3iIn`,
	"orange-100": `styles_orange-100__Bps-I`,
	"orange-200": `styles_orange-200__tAb8B`,
	"orange-300": `styles_orange-300__2t9CL`,
	"orange-400": `styles_orange-400__GoNYj`,
	"orange-500": `styles_orange-500__BAfjY`,
	"turquoise-50": `styles_turquoise-50__OgkhP`,
	"turquoise-100": `styles_turquoise-100__oUxLC`,
	"turquoise-200": `styles_turquoise-200__aqtgi`,
	"turquoise-300": `styles_turquoise-300__B4RnS`,
	"turquoise-400": `styles_turquoise-400__FlUyo`,
	"turquoise-500": `styles_turquoise-500__br9Kj`,
	"turquoise-600": `styles_turquoise-600__vDE2v`,
	"violet-50": `styles_violet-50__LBVA7`,
	"violet-100": `styles_violet-100__BxoCx`,
	"violet-200": `styles_violet-200__RZwPP`,
	"violet-300": `styles_violet-300__accxA`,
	"violet-400": `styles_violet-400__hdgk3`,
	"violet-500": `styles_violet-500__iO0Wy`,
	"snow-50": `styles_snow-50__77zsU`,
	"snow-100": `styles_snow-100__e-Log`,
	"snow-200": `styles_snow-200__K2XAV`,
	"snow-300": `styles_snow-300__GFtEX`,
	"snow-400": `styles_snow-400__6Qyqv`,
	"snow-500": `styles_snow-500__KQndH`,
	"background-color": `styles_background-color__bKCRY`,
	"ocean": `styles_ocean__yJH2f`,
	"ocean-light": `styles_ocean-light__Q9OcC`,
	"green": `styles_green__yP6hQ`,
	"green-light": `styles_green-light__apfnt`,
	"red": `styles_red__NRWrr`,
	"red-light": `styles_red-light__WJy3u`,
	"orange": `styles_orange__bcx7t`,
	"orange-light": `styles_orange-light__Zzcv7`,
	"space": `styles_space__dIFtP`,
	"space-light": `styles_space-light__j+Koe`,
	"gray-light": `styles_gray-light__lM1td`,
	"violet": `styles_violet__nbz+Z`,
	"violet-light": `styles_violet-light__dkfrj`,
	"yellow": `styles_yellow__7QPcM`,
	"yellow-light": `styles_yellow-light__rL3pH`,
	"root": `styles_root__1d62+`,
	"disabled": `styles_disabled__PDMId`,
	"clickable": `styles_clickable__hb1GI`,
	"startAdornment": `styles_startAdornment__r-TDH`,
	"endAdornment": `styles_endAdornment__tTAXo`
};
export default ___CSS_LOADER_EXPORT___;
